import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { EVENTS_API } from '../api/events-api'
import { EventId, EventViewInterface } from '../types/event-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'

export function useEvent(id: EventId) {
  const { user } = useUser()
  const { fetcher: eventFetcher } = useFetch<RequestMethodsEnum.get, EventViewInterface>({
    method: RequestMethodsEnum.get,
  })

  const {
    data: eventData,
    mutate,
    isLoading,
  } = useControlledSwr(() => {
    if (user) {
      return [`${EVENTS_API}/${id}`, RequestModuleEnum.Calendar]
    }
  }, eventFetcher)

  return { eventData, mutate, isLoading }
}
